/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import {
  Input,
  Button,
  AutoComplete,
  Modal,
  Popconfirm,
  Select,
  Form,
  Row,
  Col,
  message,
  Typography,
  Tooltip,
} from "antd";

import { PlusOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { spaceBeforeCapital } from "../../utils";
import { zoneAPI } from "../../api/RateCardApi";
import AddZoneModal from "../ZoneManagement/AddZoneModal";
const { Text } = Typography;
const DynamicRateMatrixTable = ({
  selectedMatrixData,
  onSelectedMatrixChange = () => {},
  onDeleteZone = () => {},
  onAddZone = () => {},
  defaultZones,
  actionEdit,
  customerId = null,
  rateCardType = null,
  showValueChangedPercentage = false,
  selectedDefaultRateCardMatrix = {},
  disableNewWeightSlabs = false,
  editHighValue = false,
  showHighLight = false,
  selectedOldMatrixData = {},
  selectedOriginalMatrixData = [],
  rateCardId = null,
}) => {
  const removedSlabs = [
    "volume",
    "minValue",
    "maxValue",
    "unit",
    "customValue",
  ];
  const [matrixData, setMatrixData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenCreate, setIsModalOpenCreate] = useState(false);
  const [loading, setLoading] = useState(false);
  //const [newZone, setNewZone] = useState("");
  const [maxValue, setMaxValue] = useState("");
  const [editSelectedZone, setEditSelectedZone] = useState(null);
  const [form] = Form.useForm();
  const [zoneList, setZoneList] = useState([]);
  const [addZoneId, setAddZoneId] = useState(null);
  const [addZoneUserId, setAddZoneUserId] = useState(null);
  const [debouncedFilters, setDebouncedFilters] = useState({});

  useEffect(() => {
    fetchZoneList(debouncedFilters);
  }, []);

  const fetchZoneList = async ({ debouncedFilters }) => {
    const headers = {
      //parent: JSON.parse(localStorage.getItem("userinfo"))?.roles?.[0],
      parent: localStorage.getItem("userinfo")?.roles?.includes("CP")
        ? "CP"
        : "HO",
    };

    let params = customerId
      ? { userId: customerId, page: 1, limit: 50, ...debouncedFilters }
      : { page: 1, limit: 50, ...debouncedFilters };
    let response = await zoneAPI.getAllZoneList(
      params ? { ...params } : null,
      headers
    );
    if (response?.status) {
      let data = response?.response?.data?.data;
      setZoneList(data || []);
    } else {
      message.error(response?.response?.data?.message);
    }
  };

  const handleSearch = (value, dataIndex) => {
    const updatedFilters = {
      [dataIndex]: value?.toString(),
    };
    setDebouncedFilters(updatedFilters);
  };

  useEffect(() => {
    if (debouncedFilters && Object.keys(debouncedFilters).length > 0) {
      const handler = setTimeout(() => {
        fetchZoneList({
          debouncedFilters,
        });
      }, 500);
      return () => clearTimeout(handler);
    }
  }, [debouncedFilters]);

  useEffect(() => {
    setMatrixData(selectedMatrixData);
  }, [selectedMatrixData]);

  useEffect(() => {
    setTimeout(() => {
      if (matrixData?.length > 0) {
        onSelectedMatrixChange(matrixData);
      }
    }, 100);
  }, []);

  const addNewZone = (values, actionCreate = false) => {
    if (addZoneUserId) {
      actionCreate = true;
    }

    //actionCreate = addZoneUserId ? true : false;

    const actionType = editSelectedZone ? "edit" : "add";
    onAddZone(values, actionType, editSelectedZone, addZoneId, actionCreate);

    //setMatrixData([...matrixData, { title: value }]);
    // const updatedArray = matrixData.map((item) => ({
    //   ...item,
    //   [values.name]: 0,
    // }));
    // setMatrixData(updatedArray);
    setIsModalOpen(false);
    form.resetFields();
    setEditSelectedZone(null);
    setAddZoneUserId(null);
  };

  const handleDeleteZone = (columnName) => {
    onDeleteZone(columnName);
  };

  const handleAddColumn = () => {
    setIsModalOpen(true);
  };

  // eslint-disable-next-line no-unused-vars
  const handleInputChange = (rowIndex, key, value, defaultVal) => {
    // console.log(rowIndex, key, value);

    // if (value < defaultVal && editHighValue) {
    //   message.error("value can't be less than default value");
    //   return;
    // }

    const updated = [...matrixData];
    const regex = /^\d{1,3}(\.\d{0,2})?$/;
    if (regex.test(value) || value === "") {
      updated[rowIndex][key] = value;
    }

    setMatrixData(updated);
  };

  const changeVolume = (value) => {
    const updated = [...matrixData];
    if (value != "") {
      updated[matrixData.length - 1].volume = +value;
    } else {
      updated[matrixData.length - 1].volume = 1;
    }

    setMatrixData(updated);
  };

  const handleAddWeightSlab = () => {
    let maxWeight = matrixData.reduce((max, row) => {
      if (row.maxValue && row.maxValue > max) {
        return row.maxValue;
      }
      return max;
    }, 0);

    if (parseFloat(maxWeight) >= parseFloat(maxValue)) {
      message.error("Max value cannot be less than the existing max value");
      return;
    }

    if (maxValue.trim()) {
      const volumeIndex = matrixData.findIndex((row) => "volume" in row);
      const newRow = {
        minValue:
          matrixData.slice(0, volumeIndex)[volumeIndex - 1].maxValue + 1,
        maxValue: parseFloat(maxValue),
        unit: matrixData[0]?.unit, // or whatever default unit you want
        ...Object.keys(matrixData[0] || {})
          .filter((key) => !removedSlabs.includes(key))
          .reduce((acc, key) => ({ ...acc, [key]: 0 }), {}),
      };
      if (volumeIndex !== -1) {
        const updatedData = [
          ...matrixData.slice(0, volumeIndex),
          newRow,
          ...matrixData.slice(volumeIndex),
        ];

        setMatrixData(updatedData);
      } else {
        setMatrixData([...matrixData, newRow]);
      }
      setMaxValue("");
    }
  };

  const handleDeleteWeightSlab = async (slabToDelete) => {
    let tempMatrixData = [...matrixData];
    const indexToDelete = tempMatrixData.findIndex(
      (item) =>
        item.minValue === slabToDelete.minValue &&
        item.maxValue === slabToDelete.maxValue
    );

    if (indexToDelete !== -1) {
      const prevMaxValue =
        indexToDelete > 0 ? tempMatrixData[indexToDelete - 1].maxValue : null;

      tempMatrixData.splice(indexToDelete, 1);

      if (prevMaxValue !== null && indexToDelete < tempMatrixData.length) {
        tempMatrixData[indexToDelete].minValue = prevMaxValue + 1;
      }
    }
    // const updatedMatrixData = matrixData.filter((row) => {
    //   if (row.volume) return true;
    //   return row.maxValue !== slabToDelete.maxValue;
    // });

    setMatrixData(tempMatrixData);
    message.success("Weight slab deleted successfully");
  };

  const handleEditClick = (item) => {
    form.setFieldsValue({
      name: item,
    });
    setEditSelectedZone(item);
    setIsModalOpen(true);
  };

  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) return text;
    return `${text.slice(0, maxLength)}...`;
  };

  const getPercentage = (value, defaultValue) => {
    if (value === defaultValue || defaultValue === 0) return null;

    const percentage = ((value - defaultValue) / defaultValue) * 100;
    const formatted = `${Math.abs(percentage).toFixed(0)}%`;

    const isIncrease = percentage > 0;

    return (
      <span style={{ color: isIncrease ? "#03c240" : "red", marginLeft: 4 }}>
        {isIncrease ? "↑" : "↓"} {formatted}
      </span>
    );
  };

  const getZoneDetails = async (id) => {
    setLoading(true);
    let res = await zoneAPI.getZoneById(id);
    if (res?.status) {
      let data = res?.response?.data?.data;

      // setSelectedPincodes({
      //   zone: data?.name,
      //   pincodes: data?.pincodes || [],
      // });
      // setIsViewModalOpen(true);
      form.setFieldsValue({ pincodes: data?.pincodes });
      setAddZoneId(id);
      setAddZoneUserId(data?.userId);
      setLoading(false);
    } else {
      setLoading(false);
      message.error(res?.response?.data?.message || "Internal server error.");
    }
  };

  return (
    <div style={{ overflowX: "auto" }}>
      <table border="1" className="rate-card-table mt-2">
        <thead>
          <tr>
            <th>Weight Slabs (grams)</th>

            {Object.keys(matrixData?.[0] || {}).map((item, index) => {
              return removedSlabs.includes(item) ? null : (
                <th key={index}>
                  <Tooltip title={spaceBeforeCapital(item)}>
                    <span
                      style={{
                        display: "inline-block",
                        maxWidth: "110px",
                        minWidth: "90px",
                        width: "auto",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {truncateText(spaceBeforeCapital(item), 20)}
                    </span>
                  </Tooltip>
                  {!defaultZones.includes(item) && actionEdit && (
                    <div
                      style={{
                        display: "inline-flex",
                        gap: "8px",
                        marginLeft: "8px",
                        alignItems: "center",
                      }}
                    >
                      <EditOutlined
                        onClick={() => handleEditClick(item)}
                        style={{
                          color: "#1890ff",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                      />
                      <Popconfirm
                        title="Are you sure you want to delete this zone ?"
                        onConfirm={() => handleDeleteZone(item)}
                        okText="Yes"
                        cancelText="No"
                      >
                        <DeleteOutlined
                          style={{
                            color: "#ff4d4f",
                            cursor: "pointer",
                            fontSize: "14px",
                          }}
                        />
                      </Popconfirm>
                    </div>
                  )}
                </th>
              );
            })}

            {actionEdit && (
              <th>
                <Button
                  icon={<PlusOutlined />}
                  onClick={handleAddColumn}
                  type="primary"
                />
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {matrixData?.map((item, parentIndex) => (
            <tr key={parentIndex}>
              <td style={{ textAlign: "left" }}>
                {" "}
                {item?.volume ? (
                  <div className="d-flex align-center">
                    <span>Add. Wt ({item?.unit || "gms"})&nbsp;</span>

                    <AutoComplete
                      style={{ width: "100px" }}
                      defaultValue={item?.volume || 1}
                      value={item?.volume || item?.customValue}
                      options={[{ value: 500 }, { value: 1000 }]}
                      placeholder="Additional weight"
                      onChange={(value) => changeVolume(value)}
                      // filterOption={(inputValue, option) =>
                      //   option.value
                      //     .toLowerCase()
                      //     .includes(inputValue.toLowerCase())
                      // }
                      className="td-input"
                      disabled={!actionEdit}
                    />
                  </div>
                ) : (
                  `Up to ${item?.maxValue} ${item?.unit || ""} `
                )}
              </td>
              {Object.keys(item).map(
                (key) =>
                  !removedSlabs.includes(key) && (
                    <>
                      <td key={key} style={{ textAlign: "left" }}>
                        {/* <input
                        type="text"
                        value={item[key]}
                        
                        style={{ width: "100px" }}
                      /> */}
                        {actionEdit ? (
                          <>
                            <Input
                              // status={
                              //   editHighValue &&
                              //   item[key] <
                              //     selectedDefaultRateCardMatrix?.[
                              //       parentIndex
                              //     ]?.[key]
                              //     ? "error"
                              //     : ""
                              // }
                              value={item[key]}
                              className="td-input"
                              type="number"
                              step="any"
                              onChange={(e) =>
                                handleInputChange(
                                  parentIndex,
                                  key,
                                  parseFloat(e.target.value || 0),
                                  selectedDefaultRateCardMatrix?.[
                                    parentIndex
                                  ]?.[key]
                                )
                              }
                              min={
                                editHighValue
                                  ? selectedOriginalMatrixData?.[parentIndex]?.[
                                      key
                                    ]
                                  : 0
                              }
                              //disabled={!actionEdit}
                            />
                            {editHighValue &&
                              item[key] <
                                selectedOriginalMatrixData?.[parentIndex]?.[
                                  key
                                ] && (
                                <span style={{ color: "red" }}>
                                  Must exceed previous
                                </span>
                              )}
                          </>
                        ) : showHighLight &&
                          selectedOldMatrixData?.[parentIndex]?.[key] &&
                          item[key] !=
                            selectedOldMatrixData?.[parentIndex]?.[key] ? (
                          <>
                            <Text delete>
                              {selectedOldMatrixData?.[parentIndex]?.[key]}
                            </Text>
                            <Text mark> {item[key]} </Text>
                            <Text>
                              {showValueChangedPercentage &&
                                selectedDefaultRateCardMatrix?.[parentIndex]?.[
                                  key
                                ] &&
                                getPercentage(
                                  item[key],
                                  selectedDefaultRateCardMatrix?.[
                                    parentIndex
                                  ]?.[key]
                                )}
                            </Text>
                          </>
                        ) : (
                          <Text>
                            {item[key]}
                            {showValueChangedPercentage &&
                              selectedDefaultRateCardMatrix?.[parentIndex]?.[
                                key
                              ] &&
                              getPercentage(
                                item[key],
                                selectedDefaultRateCardMatrix?.[parentIndex]?.[
                                  key
                                ]
                              )}
                          </Text>
                        )}
                      </td>
                    </>
                  )
              )}
              {!item?.volume && actionEdit && (
                <td>
                  <Popconfirm
                    title="Are you sure you want to delete this weight slab?"
                    onConfirm={() => handleDeleteWeightSlab(item)}
                    okText="Yes"
                    cancelText="No"
                    okButtonProps={{ danger: true }}
                  >
                    <DeleteOutlined
                      style={{
                        color: "#ff4d4f",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    />
                  </Popconfirm>
                </td>
              )}
            </tr>
          ))}
          {actionEdit && !disableNewWeightSlabs && (
            <tr className="add-row">
              <td>
                <Input
                  placeholder="Enter new slab"
                  value={maxValue}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || /^\d*\.?\d*$/.test(value)) {
                      setMaxValue(value);
                    }
                  }}
                  suffix={
                    <Button
                      type="text"
                      icon={<PlusOutlined />}
                      onClick={handleAddWeightSlab}
                      style={{ border: "none" }}
                      disabled={!maxValue.trim()}
                    />
                  }
                  style={{ width: "80%" }}
                />
              </td>
              {Object.keys(matrixData?.[0] || {}).map((key) =>
                !removedSlabs.includes(key) ? <td key={key}>-</td> : null
              )}
            </tr>
          )}
        </tbody>
      </table>

      {/* New Zone Modal */}
      <Modal
        title={editSelectedZone ? "Edit Zone" : "Add New Zone"}
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          form.resetFields();
          setEditSelectedZone(null);
          setAddZoneUserId(null);
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setIsModalOpen(false);
              form.resetFields();
              setEditSelectedZone(null);
              setAddZoneUserId(null);
            }}
          >
            Cancel
          </Button>,
          <Button key={"submit"} onClick={() => form.submit()} type="primary">
            {editSelectedZone ? "Update" : "Add"}
          </Button>,
        ]}
        width={1000}
      >
        <Form
          layout="vertical"
          form={form}
          scrollToFirstError={{
            behavior: "smooth",
            block: "center",
            inline: "center",
          }}
          onFinish={addNewZone}
          className="global-form add-zone-form"
        >
          <Row gutter={20} className="mt-1 global-form-row">
            <Col span={18}>
              <Form.Item name="name" label="Select Zone">
                <Select
                  showSearch
                  placeholder="Select Zone"
                  onChange={(val, items) => {
                    getZoneDetails(items?.id);
                    //form.setFieldsValue({ pincodes: items?.pincodes });
                    setAddZoneId(items?.id);
                    setAddZoneUserId(items?.userId);
                  }}
                  //options={zoneList}
                  options={zoneList?.map((item) => ({
                    label: item?.name,
                    value: item?.name,
                    pincodes: item?.pincodes,
                    id: item?.id,
                    userId: item?.userId,

                    disabled: Object.keys(matrixData?.[0] || {}).some(
                      (key) => key === item?.name
                    ),
                  }))}
                  onSearch={(val) => {
                    handleSearch(val, "searchTerm");
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label=" ">
                <Button
                  className="save-btn"
                  onClick={() => setIsModalOpenCreate(true)}
                >
                  Create Zone
                </Button>
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item name="pincodes" label="Pincodes">
                <Select
                  className="pincode-tag"
                  size="small"
                  mode="tags"
                  placeholder="Pincodes"
                  disabled
                  //value={selectedServices}
                  //onChange={setSelectedServices}
                  //options={serviceOptions}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <AddZoneModal
        isModalOpen={isModalOpenCreate}
        setIsModalOpen={(val, values) => {
          setIsModalOpenCreate(val);
          setIsModalOpen(false);
          addNewZone(values, "create");
        }}
        editSelectedZone={editSelectedZone}
        getAllZoneList={() => fetchZoneList()}
        customerId={customerId}
        rateCardType={rateCardType}
        action={"assign_customer"}
        rateCardId={rateCardId}
      />
    </div>
  );
};

export default DynamicRateMatrixTable;
